import { Box, CircularProgress } from '@mui/material';

export function ConvertingOverlay() {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(0,0,0,0.5)',
      }}
    >
      <CircularProgress size={24} color="inherit" />
    </Box>
  );
}
